var _tspan, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDigitalpersonalfilesAmico1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-52"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-52",
    cx: 249,
    cy: 352.72,
    rx: 240.78,
    ry: 139.01,
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-52"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-52",
    cx: 425.72,
    cy: 433.26,
    rx: 59.56,
    ry: 34.38,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-52",
    d: "M39.88,387.16c-11.23,6.49-11.23,17,0,23.5s29.46,6.49,40.7,0,11.24-17,0-23.5S51.12,380.67,39.88,387.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-52",
    d: "M341,420.84l-83.08-48a7,7,0,0,0-6.32,0L145.08,434.34c-1.75,1-1.75,2.64,0,3.65l20.24,11.68L156.1,455v2.67l-1.3.76a.61.61,0,0,0,0,1.16l1.38.8-9.45,5.46a8,8,0,0,1-7.14,0L88,436.06c-.77-.44-1.21-1-1.21-1.52s.44-1.08,1.21-1.52l52-30a9,9,0,0,1-.7-1.74l-52.2,30.09a3.36,3.36,0,0,0,0,6.26l51.59,29.79a9.79,9.79,0,0,0,9,0l10.38-6,1.68,1a2.25,2.25,0,0,0,2,0l1.3-.75h4.62l9.22-5.32L228.15,486a7,7,0,0,0,6.33,0L341,424.49C342.7,423.48,342.7,421.85,341,420.84Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Frame--inject-52"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "27.38 240 29.64 241.35 106.42 197.02 104.16 195.67 27.38 240",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.16 195.67 29.64 238.69 29.64 72.76 104.17 29.75 104.16 195.67",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.68,21.05,25.38,70.3V248.73l85.3-49.25Zm-4.26,176L29.64,241.35V72.76l76.78-44.33Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.42 197.02 104.16 195.67 104.17 29.75 106.42 28.43 106.42 197.02",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.64 180.88 29.64 183.53 106.42 139.19 104.16 137.85 29.64 180.88",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.64 123.03 29.64 125.68 106.42 81.35 104.16 80 29.64 123.03",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.68 21.05 108.39 19.74 23.09 68.99 25.38 70.3 110.68 21.05",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.09 68.99 25.38 70.3 25.38 248.72 23.09 247.41 23.09 68.99",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.48 53.8 64.77 52.47 64.77 221.07 62.48 219.76 62.48 53.8",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "69.03 50.03 64.77 52.47 64.77 221.07 69.03 218.6 69.03 50.03",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.68 78.89 110.68 83.8 25.38 133.05 25.38 128.14 110.68 78.89",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.68 136.72 110.68 141.64 25.38 190.89 25.38 185.97 110.68 136.72",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.77 105.39 62.48 104.07 29.64 123.03 29.64 125.68 64.77 105.39",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.77 163.22 62.48 161.89 29.64 180.85 29.64 183.5 64.77 163.22",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pictures--inject-52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-52"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "136.52 85.89 138.16 86.87 171.79 67.45 170.15 66.47 136.52 85.89",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.15 66.47 138.16 84.94 138.16 51.44 170.15 32.98 170.15 66.47",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.88,26.67l-39.81,23V92.22l39.81-23Zm-3.09,40.78L138.16,86.87V51.44L171.79,32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.79 67.45 170.15 66.47 170.15 32.98 171.79 32.02 171.79 67.45",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.88 26.67 173.22 25.71 133.4 48.7 135.07 49.65 174.88 26.67",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.4 48.7 135.07 49.65 135.07 92.22 133.4 91.27 133.4 48.7",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Land--inject-52"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "168.9 65.47 139.41 82.5 139.41 73.98 146.78 56.96 151.38 61.22 149.72 68.35 159.91 46.57 168.9 56.96 168.9 65.47",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.1,48.74a4.78,4.78,0,0,0-2.18,3.77c0,1.4,1,2,2.18,1.26A4.81,4.81,0,0,0,153.28,50C153.28,48.6,152.3,48,151.1,48.74Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--picture--inject-52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-52"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "189.26 78.77 190.9 79.74 224.53 60.33 222.89 59.35 189.26 78.77",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.89 59.35 190.9 77.82 190.9 44.32 222.89 25.86 222.89 59.35",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.62,19.55l-39.81,23V85.1l39.81-23Zm-3.09,40.78L190.9,79.74V44.32L224.53,24.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.53 60.33 222.89 59.35 222.89 25.86 224.53 24.9 224.53 60.33",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.62 19.55 225.96 18.59 186.15 41.58 187.81 42.53 227.62 19.55",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.15 41.58 187.81 42.53 187.81 85.1 186.15 84.15 186.15 41.58",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--land--inject-52"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "221.64 58.35 192.15 75.38 192.15 66.86 199.52 49.84 204.12 54.09 202.47 61.23 212.65 39.45 221.64 49.84 221.64 58.35",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.84,41.61a4.82,4.82,0,0,0-2.18,3.78c0,1.39,1,2,2.18,1.26A4.83,4.83,0,0,0,206,42.87C206,41.48,205,40.92,203.84,41.61Z",
    style: {
      fill: "#f0f0f0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant--inject-52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.37,401.24c-9-9.31-14.31-47.18-5.52-54.56H82.61c8.8,7.38,3.51,45.24-5.51,54.55-.07.09-.16.17-.24.26s-.21.21-.31.31c-.26.25-.53.49-.82.73l-.22.17c-.22.18-.44.35-.68.52a11.4,11.4,0,0,1-1.16.75c-7.42,4.33-19.45,4.33-26.87,0h0a10.61,10.61,0,0,1-1.17-.76c-.23-.15-.43-.32-.64-.48l-.26-.21c-.28-.23-.54-.47-.79-.71l-.36-.35Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.37,401.24c-9-9.31-14.31-47.18-5.52-54.56H82.61c8.8,7.38,3.51,45.24-5.51,54.55-.07.09-.16.17-.24.26s-.21.21-.31.31c-.26.25-.53.49-.82.73l-.22.17c-.22.18-.44.35-.68.52a11.4,11.4,0,0,1-1.16.75c-7.42,4.33-19.45,4.33-26.87,0h0a10.61,10.61,0,0,1-1.17-.76c-.23-.15-.43-.32-.64-.48l-.26-.21c-.28-.23-.54-.47-.79-.71l-.36-.35Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.73,343.71c10.21,6,10.21,15.63,0,21.59s-26.78,6-37,0-10.21-15.63,0-21.59S68.51,337.74,78.73,343.71Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.73,343.71c10.21,6,10.21,15.63,0,21.59s-26.78,6-37,0-10.21-15.63,0-21.59S68.51,337.74,78.73,343.71Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.81,346.57c7.5,4.38,7.5,11.48,0,15.86s-19.66,4.38-27.16,0-7.5-11.48,0-15.86S66.31,342.19,73.81,346.57Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.81,346.57c7.5,4.38,7.5,11.48,0,15.86s-19.66,4.38-27.16,0-7.5-11.48,0-15.86S66.31,342.19,73.81,346.57Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.65,354.1c7.5-4.38,19.66-4.38,27.16,0a12.62,12.62,0,0,1,4.5,4.16,12.55,12.55,0,0,1-4.5,4.17c-7.5,4.38-19.66,4.38-27.16,0a12.6,12.6,0,0,1-4.49-4.17A12.67,12.67,0,0,1,46.65,354.1Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.27,274.91a4.65,4.65,0,0,1,0-.67c0-.23,0-.46-.07-.69-.05-.45-.12-.9-.2-1.36-.18-.9-.41-1.79-.67-2.67a2,2,0,0,0-.16-.52c0-.17-.11-.34-.16-.52l-.36-1.05c-.17-.5-.34-1-.52-1.5a13,13,0,0,1-.48-1.45,2.09,2.09,0,0,0-.14-.56,1.14,1.14,0,0,1-.09-.26c0-.24-.09-.49-.15-.73-.1-.49-.22-1-.35-1.46-.25-1-.56-1.92-.9-2.86-.28-.74-.58-1.47-.91-2.19a7.67,7.67,0,0,0-2.48-3.33,1,1,0,0,0-1-.18c-.33.17-.4.62-.43,1-.14,2.14-.28,4.27-.43,6.41a18.72,18.72,0,0,0,0,4,9.51,9.51,0,0,0,2.2,4.83,19.28,19.28,0,0,0,2.59,2.35c.7.55,1.41,1.09,2.09,1.67A8.8,8.8,0,0,0,47.27,274.91Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.89,261.42c-.06-.31-.12-.62-.2-.92a6.19,6.19,0,0,0-.79-1.85c-.17-.29-.27-.61-.43-.9a3.39,3.39,0,0,0-.66-.8,1.31,1.31,0,0,0-.54-.3.59.59,0,0,0-.58.17,1,1,0,0,0-.15.51,17,17,0,0,1-.68,3.39,10.18,10.18,0,0,1-.58,1.63,2.74,2.74,0,0,1-.3.43,2.07,2.07,0,0,0-.19.32,9,9,0,0,1-.88,1.54,8.34,8.34,0,0,1-.86,1,20,20,0,0,0-3,3c-1.13,1.79-.94,4.08-1,6.1,0,.34,0,.69,0,1,0,2.77-.45,5.17.26,7.9,0,.19.25.66.55.48a3.28,3.28,0,0,0,.31-.2,10.27,10.27,0,0,0,3.1-4.6c.19-.45.37-.91.55-1.36a3.3,3.3,0,0,1,.65-.87c.67-.87,1.25-1.86,1.83-2.79a27.64,27.64,0,0,0,3-6,15.46,15.46,0,0,0,.81-4.77A12.9,12.9,0,0,0,59.89,261.42Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.67,283.27c.52,0,1,.05,1.58.05,1.08,0,2.16,0,3.23,0H47.1a5.24,5.24,0,0,1,.56,0,5,5,0,0,0,.77,0,.29.29,0,0,0,.16,0,.3.3,0,0,0,.07-.23,4.56,4.56,0,0,0-.51-2.14,4.79,4.79,0,0,0-.62-.92,8.34,8.34,0,0,0-2.78-2.19,14.72,14.72,0,0,0-3.26-1l-8.8-1.88a1.22,1.22,0,0,0-1.17.15,1.06,1.06,0,0,0-.22.65,6.5,6.5,0,0,0,3,5.67A12.48,12.48,0,0,0,40.67,283.27Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.33,294.08a5.36,5.36,0,0,0-1-1.29,6.84,6.84,0,0,0-2.06-1.38,23.36,23.36,0,0,0-4-1.17,47.39,47.39,0,0,1-9-3.21,1.13,1.13,0,0,0-.61-.17c-.52.05-.72.69-.75,1.2A7.49,7.49,0,0,0,36.82,295c2.43,1.26,5.32,1.06,8.06,1H45a22.47,22.47,0,0,1,3,.06,10.18,10.18,0,0,1,1.45.23c.4.09,1.13.52,1.39,0a1,1,0,0,0,0-.62,4.85,4.85,0,0,0-.48-1.45Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.31,294.85a2,2,0,0,1-.41.31.88.88,0,0,1-.35.1.52.52,0,0,1-.45-.23,2.26,2.26,0,0,1-.16-.26,5.55,5.55,0,0,1-.24-.56,5.91,5.91,0,0,1-.29-1.19c0-.09,0-.19,0-.29,0-.45-.09-.91-.13-1.36,0-.23,0-.46-.09-.69a1.45,1.45,0,0,1,0-.51,3.82,3.82,0,0,0,0-.83,8.81,8.81,0,0,1,0-1c.26-3,2.46-5.46,4.28-7.9a38.35,38.35,0,0,0,4.18-7.1c.24-.56.65-1.22,1.25-1.13s.74.59.89,1.05a16.09,16.09,0,0,1-.25,10.1,22.62,22.62,0,0,1-2.77,5.43,29.18,29.18,0,0,1-1.88,2.43c-.19.23-.37.46-.58.68-.63.68-1.27,1.34-1.92,2l-.8.8Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.74,303.24A25.3,25.3,0,0,0,41.5,302a14.44,14.44,0,0,1-6.06-1.81,1.19,1.19,0,0,0-.63-.25c-.44,0-.66.53-.72,1a5.88,5.88,0,0,0,1,3.73,11.17,11.17,0,0,0,11.15,5.09h0c1.38-.24,2.71-.73,4.1-.88a7.06,7.06,0,0,1,1,0c.21,0,.57.14.74,0,.37-.4-.07-.94-.16-1.33a4.45,4.45,0,0,0-.61-1.35A7.13,7.13,0,0,0,49.27,304,9.19,9.19,0,0,0,47.74,303.24Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.87,315.68c-2.1-.52-4.3-.63-6.34-1.36-.91-.33-1.78-.77-2.68-1.14-.25-.1-.58-.18-.76,0a.63.63,0,0,0-.14.46,7.11,7.11,0,0,0,3.21,5.82,11.74,11.74,0,0,0,6.57,1.86c1.39,0,2.77-.11,4.15,0a3.45,3.45,0,0,1,1,.15c.16.07.26.25.42.3.62.21.7-.67.63-1.05a5.06,5.06,0,0,0-.82-2,4.28,4.28,0,0,0-.7-.83,1.33,1.33,0,0,0-.35-.19c-.6-.29-1.09-.79-1.68-1.1A10.45,10.45,0,0,0,47.87,315.68Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,358c-.15-.7-.24-1.41-.44-2.09s-.46-1.52-.68-2.28c-.41-1.39-.77-2.8-1.08-4.21q-1-4.33-1.55-8.74c-.75-5.91-1-11.86-1.27-17.8s-.51-11.94-1.13-17.87a154.09,154.09,0,0,0-3-18.13A106.83,106.83,0,0,0,44,266.67c-.07-.16-.21.06-.18.16,3.62,11.9,6.75,24,8.19,36.35,1.36,11.7,1,23.52,2.3,35.22.36,3.21.84,6.4,1.51,9.55.33,1.57.74,3.12,1.2,4.65.27.9.56,1.8.88,2.69a19.6,19.6,0,0,0,1.37,2.8C59.49,358.42,60.08,358.44,60,358Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.49,283.73a3.93,3.93,0,0,0-1.62-1.66A10.51,10.51,0,0,0,45.62,281c-2-.69-4.08-1.17-6.11-1.78-.12,0-.17.26-.06.3,1.88.65,3.75,1.35,5.62,2a14.48,14.48,0,0,1,2.18.94,6.14,6.14,0,0,1,1,.67c.34.29.6.65.92.94S49.57,283.93,49.49,283.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,297.4c-.84-2.63-3.61-4.15-6.15-4.65-1.39-.28-2.8-.34-4.2-.53A12.8,12.8,0,0,1,37.73,291c-.07,0-.1.14-.06.18,1.91,1.75,5,1.81,7.45,2.22a10,10,0,0,1,3.76,1.28,9.2,9.2,0,0,1,2.74,3C51.8,298,52.06,297.64,52,297.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,309.63a5.16,5.16,0,0,0-2.61-2.23,13.62,13.62,0,0,0-3.71-1.07c-2.59-.42-5.34-.51-7.56-2.08,0,0-.06.05,0,.07,1.85,1.77,4.44,2.25,6.87,2.73a21.26,21.26,0,0,1,3.61.93,9.2,9.2,0,0,1,1.6.8c.55.37,1,.86,1.51,1.27C53,310.28,53.13,309.83,53,309.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.85,321.54a3.3,3.3,0,0,0-1.39-1.78,6.64,6.64,0,0,0-2.27-1.06c-2-.52-4.17-.22-6.16-.89-.09,0-.13.18,0,.22,1.81.74,3.75.79,5.63,1.24a8.45,8.45,0,0,1,2.17.85,4.63,4.63,0,0,1,.9.68,11.45,11.45,0,0,1,.73,1C53.63,322.05,53.88,321.81,53.85,321.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.73,267.14a17.29,17.29,0,0,1-2.55,4.16,19.35,19.35,0,0,0-2.48,4,19.63,19.63,0,0,0-1.27,4.38,13.8,13.8,0,0,0-.24,2.48,11.6,11.6,0,0,0,.32,2.28c.05.24.32.35.34,0,.09-.93.29-1.84.38-2.77a18.75,18.75,0,0,1,.32-2.25,22.45,22.45,0,0,1,1.38-4.3c1.15-2.72,3.11-5.07,4-7.89C56,267.14,55.81,266.93,55.73,267.14Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,282.66c-1.14,2.19-2.93,4-4.32,6a14.73,14.73,0,0,0-1.77,3.55,7,7,0,0,0-.17,3.82c0,.23.3.2.31,0a15.76,15.76,0,0,1,2.58-6.86,43.6,43.6,0,0,0,3.49-6.4C58.11,282.68,58,282.52,58,282.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6,321.22a22.14,22.14,0,0,0-3.11-1.48l-7.09-2.92a1.09,1.09,0,0,0-1-.06,1,1,0,0,0-.33.75,7.38,7.38,0,0,0,.42,3,12,12,0,0,0,9.14,8.22c1.78.27,3.62.08,5.38.49.7.16,1.85.39,1.86-.67a1.61,1.61,0,0,0-.29-.76c-.17-.35-.25-.74-.39-1.1a11.34,11.34,0,0,0-2.51-3.86A10.38,10.38,0,0,0,39.6,321.22Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.22,333.22a17,17,0,0,0-4.46-1.11l-4.07-.64-1.58-.25a.87.87,0,0,1-.22-.05,1.2,1.2,0,0,0-.66-.16c-.31.06-.36.26-.38.53a4.56,4.56,0,0,0,.15,1.6,6,6,0,0,0,1.73,2.8,10.15,10.15,0,0,0,4.91,2.24,19.14,19.14,0,0,0,4.4.36c1.24-.05,2.48-.32,3.09-1.51s-.4-2-1.14-2.69A7,7,0,0,0,43.22,333.22Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.86,324.61a1.79,1.79,0,0,1,.09-.86,1,1,0,0,1,1-.5,2,2,0,0,1,1.06.54c1.25,1.13,1.57,2.94,1.73,4.62a15.83,15.83,0,0,1-.18,5.14c-.3,1.23-.87,2.82-2.28,3.11a2.42,2.42,0,0,1-2.54-1.2c-.79-1.43-.1-3.32.26-4.78a22.62,22.62,0,0,0,.86-5.42C47.88,325.05,47.88,324.83,47.86,324.61Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.89,342.74a19.77,19.77,0,0,0-5.39-1.19l-2-.25a.89.89,0,0,0-.43,0c-.45.14-.48.76-.34,1.21.61,1.93,2.72,3,4.71,3.34s4.08.34,5.94,1.12c.43.18,1.12.48,1.4-.07s-.18-.78-.37-1.14a6.3,6.3,0,0,0-2-2.2A8.26,8.26,0,0,0,44.89,342.74Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.94,340.32c.64-1.58,2-2.86,2.28-4.54a.89.89,0,0,1,.9.39,2.7,2.7,0,0,1,.36,1,18.71,18.71,0,0,1,.62,3.93,6.4,6.4,0,0,1-1,3.78,2.26,2.26,0,0,1-1.64,1.06,2,2,0,0,1-1.54-.61c-.61-.68-.42-1.65-.38-2.49A7.28,7.28,0,0,1,48.94,340.32Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.42,359.19a18.06,18.06,0,0,1-2.78-6.46c-.49-1.94-.86-3.93-1.23-5.9a5.4,5.4,0,0,1,.31-1.26,12.25,12.25,0,0,1,.57-1.34c.11-.22.23-.43.33-.65a2.86,2.86,0,0,0,.27-1s0-.1-.06-.09c-.55.19-.83.74-1.12,1.21a10.32,10.32,0,0,0-.66,1.28q-.66-3.36-1.33-6.74h0a11,11,0,0,1,.26-1.1c.22-.71.58-1.37.87-2.06a9.53,9.53,0,0,0,.69-2.28,6.39,6.39,0,0,0,.17-2.22c0-.2-.21,0-.19.14.12.81-.55,1.58-.9,2.26s-.67,1.25-1,1.88c-.15.29-.29.59-.43.89a21.56,21.56,0,0,0-1.78-6.2,10.31,10.31,0,0,0-2.34-3,10.54,10.54,0,0,0-1.85-1.25,16.54,16.54,0,0,0-2.22-.88c-.07,0-.12.15-.06.19.57.37,1.08.8,1.65,1.16a15.72,15.72,0,0,1,1.76,1.27,6.77,6.77,0,0,1,2,2.74A35.34,35.34,0,0,1,46,336.4a18.26,18.26,0,0,0-3.21-.55,9.87,9.87,0,0,1-3.33-1c-.15-.08-.21.24-.11.31a7.78,7.78,0,0,0,3.39,1.34c.61.13,1.21.24,1.82.38s1.09.3,1.63.45c.49,2.59,1,5.16,1.51,7.74.06.28.11.57.17.86a3.61,3.61,0,0,0-.44-.33,5.71,5.71,0,0,0-1.26-.63,2.84,2.84,0,0,0-.7-.16c-.22,0-.43,0-.65,0s-.18.32,0,.35a7.51,7.51,0,0,1,1.29.43,6.79,6.79,0,0,1,1.11.56,6,6,0,0,1,.84.66c.37,1.93.73,3.86,1.21,5.76a20,20,0,0,0,1.18,3.52,10.41,10.41,0,0,0,2.79,3.65C53.54,360.06,53.56,359.38,53.42,359.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7,265.4c1.66-3.48,4.66-6.26,5.87-9.92a1.2,1.2,0,0,1,.27-.51.72.72,0,0,1,.93.11,2,2,0,0,1,.44.91,15.29,15.29,0,0,1,.35,8.34A28.67,28.67,0,0,1,89.07,268c-.94,2.11-1.68,4.32-2.82,6.32a12.67,12.67,0,0,1-2.36,3c-.7.63-1.93,1.73-2.68.55a3.23,3.23,0,0,1-.29-1.74c0-.71,0-1.41,0-2.11a29.41,29.41,0,0,1,.39-4.19,17.8,17.8,0,0,1,1.16-4Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1,278.55a17.93,17.93,0,0,0-2.29-5.28l-3.73-6.54c-.1-.17-.23-.36-.42-.38s-.37.19-.48.36a11.34,11.34,0,0,0-.51,9.76,26.16,26.16,0,0,0,5.61,8.32,1.06,1.06,0,0,0,1.14.43,1.5,1.5,0,0,0,.73-1.16,1.35,1.35,0,0,0-.05-.45,6.72,6.72,0,0,1,.08-1.26c0-.51.09-1,.1-1.55A10.63,10.63,0,0,0,77.1,278.55Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.79,276.24l3.61-1.79a.5.5,0,0,1,.31-.08c.18,0,.26.24.3.42a5.59,5.59,0,0,1-.63,3.77,12.45,12.45,0,0,1-2.44,3,29.92,29.92,0,0,1-3,2.57,28,28,0,0,1-3.41,2.16,25.51,25.51,0,0,1-3.67,1.61,23.45,23.45,0,0,1-3.86,1c-.7.11-1.63.23-1.76-.69a3.9,3.9,0,0,1,.71-2.39,10.39,10.39,0,0,1,2.25-2.52,31.41,31.41,0,0,1,3.34-2.52c1.17-.77,2.38-1.48,3.61-2.15s2.49-1.31,3.76-1.93Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.29,289.88a23.7,23.7,0,0,0-1.22-3,52.33,52.33,0,0,1-2.62-7.29c-.41-.05-.74.3-1,.62a12.43,12.43,0,0,0-2.63,6.85,9.12,9.12,0,0,0,2.47,6.81c1.28,1.29,3,2.16,3.92,3.73.17.29.34.63.66.73a.48.48,0,0,0,.52-.23c.09-.19-.05-.37,0-.58.06-.62.16-1.25.22-1.87a19.28,19.28,0,0,0,.07-3.72A10.92,10.92,0,0,0,70.29,289.88Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.39,294.87c1.86-1.54,4.38-2,6.77-2.28s4.9-.54,7-1.77a1.57,1.57,0,0,1,.75-.3c.7,0,1,.92.88,1.61a6.49,6.49,0,0,1-1.35,2.65,13,13,0,0,1-2,2.19c-2.66,2.18-6.37,2.37-9.81,2.45l-2.46.06-1.25,0a9.62,9.62,0,0,1-1.2,0c-.62-.07-.12-.81,0-1.1.34-.61.67-1.22,1.06-1.8A8.69,8.69,0,0,1,74.39,294.87Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.11,303.87a14.77,14.77,0,0,0-1.49-2.94q-1.5-2.48-3-4.95c-.32-.52-.73-1.1-1.33-1.12-1.42,3.81-2.2,8.21-.38,11.85A18.22,18.22,0,0,0,61.24,310l2.52,3.08c.34.42,1,.87,1.57.57.26-.14.3-.47.35-.74a7.76,7.76,0,0,0,.16-1.26,4.21,4.21,0,0,0,0-.94,13.94,13.94,0,0,1-.21-2.74A12.89,12.89,0,0,0,65.11,303.87Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,305.61a10.65,10.65,0,0,1,2.67-1c1.09-.23,2.21-.24,3.31-.38,1.82-.22,3.57-.78,5.38-1.06a.94.94,0,0,1,.55,0,.83.83,0,0,1,.35.72,6.28,6.28,0,0,1-.93,3.51A12.63,12.63,0,0,1,77,313.58a31.66,31.66,0,0,1-4.86.41c-.82,0-1.63.09-2.44.2a12.32,12.32,0,0,0-1.21.24,1.11,1.11,0,0,1-.74,0c-.4-.18-.42-.72-.38-1.09a4.6,4.6,0,0,1,.59-1.65,14.89,14.89,0,0,1,5.66-5.87Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.79,314.89a31.64,31.64,0,0,0-.5,5,16.55,16.55,0,0,0,.89,6.3,22.2,22.2,0,0,0,3.8,5.82.64.64,0,0,0,.33.26c.29.07.51-.26.62-.54a14.7,14.7,0,0,0,.83-7.93,15.36,15.36,0,0,0-1.21-3.92c-.27-.57-.66-1.09-.88-1.68-.06-.13-.08-.28-.13-.42a10.77,10.77,0,0,0-.7-1.23,15.92,15.92,0,0,1-1.2-2.74,1.53,1.53,0,0,0-.52-.86.59.59,0,0,0-.59,0c-.21.13-.18.31-.27.51a5.11,5.11,0,0,0-.31.67A6.36,6.36,0,0,0,56.79,314.89Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,321.22a9.1,9.1,0,0,1,2.61-3,11.57,11.57,0,0,1,2.82-1.2l7.37-2.38a9.09,9.09,0,0,1-2.67,7.48,26.18,26.18,0,0,1-6.32,4.63c-1.63,1-3.3,1.66-4.2,2.27-.41.28-.81.56-1.2.86s-.86.72-1.19.37c-.15-.17-.06-.46,0-.66s.11-.56.18-.84l.3-1.07c.1-.35.2-.7.27-1,0-.17.07-.35.1-.52a15.75,15.75,0,0,1,.74-2.54A17.16,17.16,0,0,1,66,321.22Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.78,277.35c.67-1.78,1.25-3.6,1.75-5.43s.77-3.82,1.09-5.75c0-.23-.21-.39-.28-.11-.41,1.75-1,3.45-1.59,5.15s-1.17,3.33-1.86,5a74.35,74.35,0,0,1-4.63,9.12l-.7,1.17v-.77a16.52,16.52,0,0,0-.29-3.21,19.48,19.48,0,0,0-.79-2.93,6.75,6.75,0,0,0-1.38-2.72c-.11-.09-.19.09-.18.18a20.53,20.53,0,0,0,1,2.68,16.67,16.67,0,0,1,.65,2.88,19.38,19.38,0,0,1,.15,2.95,20.42,20.42,0,0,0-.13,2.59c-1.27,2.09-2.52,4.18-3.65,6.34q-.77,1.47-1.47,3l0-.13A18.5,18.5,0,0,0,69.2,294c-1.11-2.47-2.39-4.87-2.81-7.57,0-.14-.15,0-.15.06a21.18,21.18,0,0,0,1.68,6.76c.43,1.18.83,2.36,1.15,3.57a13.43,13.43,0,0,1,.33,1.79c0,.3.06.6.11.89l-.15.36a3.27,3.27,0,0,0-.46,1.07c-.32.77-.64,1.54-.94,2.32-1.09,2.81-2,5.67-2.86,8.56a18.29,18.29,0,0,0-.86-3.15,18.08,18.08,0,0,0-1.42-3.06,10.5,10.5,0,0,0-2-2.87c-.1-.08-.14.18-.12.24.44,1,1.1,1.86,1.53,2.86a28.15,28.15,0,0,1,1.11,2.94A43.48,43.48,0,0,1,64.48,314a113.23,113.23,0,0,0-2.41,11.86c-.62-1.54-1.42-3-2.18-4.46-.1-.2-.26.1-.21.22a31,31,0,0,1,1.82,5.62q.12.59.21,1.17c-.55,4.26-.88,8.55-1,12.83,0,.65.07,4.56.15,7a39.26,39.26,0,0,0,.55,6,16.35,16.35,0,0,0,.91,3.12c.21.46.7.92,1.16.71-.1-.76-.14-1.52-.31-2.26a54.31,54.31,0,0,1-.95-10c0-1.08,0-2.16,0-3.24.08-3.34.28-6.69.61-10a12.22,12.22,0,0,1,1.34-2.62c1.53-2.22,3.88-3.67,5.48-5.81.09-.12,0-.59-.18-.46a26.55,26.55,0,0,0-3.6,2.72,13.93,13.93,0,0,0-2.65,2.72c.24-1.94.52-3.89.86-5.82q.57-3.22,1.34-6.4a12,12,0,0,0,.8-1c.35-.46.68-.93,1.06-1.37a11.35,11.35,0,0,1,2.52-2.12,10.64,10.64,0,0,1,2.72-1.2,13.81,13.81,0,0,1,1.38-.33,4.44,4.44,0,0,0,1.45-.33c.06,0,.09-.2,0-.23a5.55,5.55,0,0,0-3.49,0,11.06,11.06,0,0,0-3.23,1.3,11.4,11.4,0,0,0-2.43,2.06c.81-3,1.76-5.95,2.84-8.85q1-2.59,2.1-5.1a8.06,8.06,0,0,1,1.93-1.11,24.39,24.39,0,0,1,2.93-.94,17.9,17.9,0,0,0,2.73-1.1c.11-.05.13-.36,0-.32-1.13.31-2.35.4-3.51.62a15,15,0,0,0-3.14.88c1.13-2.37,2.34-4.68,3.63-7a11,11,0,0,1,1.41-1.65,16.86,16.86,0,0,1,2.67-1.63,63.47,63.47,0,0,0,5.63-3.42c.11-.08.07-.44-.11-.37a61.36,61.36,0,0,0-6.47,3.16c-.4.22-.85.45-1.29.71,0,0,.07-.11.11-.17A64.73,64.73,0,0,0,82.78,277.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4,346.18a14.15,14.15,0,0,0-.5-3.37,7.53,7.53,0,0,0-2.27-4.06,2.93,2.93,0,0,0-2.27-.63c.23,1.6.47,3.21.7,4.81,0,.17,0,.34.08.51A8.65,8.65,0,0,0,64.25,347a4.75,4.75,0,0,0,.63.64,7.34,7.34,0,0,0,1.41,1.14l.24.13a.66.66,0,0,0,.38.12c.45,0,.39-.71.43-1,0-.53.07-1.07.07-1.61C67.41,346.3,67.4,346.24,67.4,346.18Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.08,340.13a14.15,14.15,0,0,0,2.56-1.47c.18-.13.41-.27.59-.16a.54.54,0,0,1,.2.31,4,4,0,0,1-1.05,3.37,12.72,12.72,0,0,1-3.1,3,9.25,9.25,0,0,1-3.91,1.55c-.82.11-2.65.26-2.3-1.09a4.57,4.57,0,0,1,.8-1.47,14.7,14.7,0,0,1,1.3-1.54c1.2-1.19,2.85-1.65,4.37-2.26Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.29,331.32a13.87,13.87,0,0,1,9,.31,3.84,3.84,0,0,1,1.93,1.19,1.55,1.55,0,0,1-.11,2.07,2.12,2.12,0,0,1-.88.35l-13.94,3.43a3.47,3.47,0,0,1-1.11.11c-.19,0-.35-.12-.52-.15s-.29.06-.39-.11a.65.65,0,0,1-.06-.34,4.11,4.11,0,0,1,.07-.86,1.74,1.74,0,0,1,.14-.38c.16-.3.28-.63.43-.94a9,9,0,0,1,3.09-3.49A9.64,9.64,0,0,1,75.29,331.32Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.78,323c2.39-1.25,5.19-1.37,7.88-1.46a.6.6,0,0,1,.44.11.52.52,0,0,1,.13.3,4.12,4.12,0,0,1-1.29,3.24,10.58,10.58,0,0,1-3.43,2.54,20.67,20.67,0,0,1-3.94,1.22L74,329.8c-.23.06-.78.35-1,.18s0-.91.05-1.14a7.6,7.6,0,0,1,.68-1.37A11.06,11.06,0,0,1,75.21,325,9,9,0,0,1,77.78,323Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.72,330.68c-.07-.05-.15-.1-.23-.06a.22.22,0,0,0-.1.17,2.37,2.37,0,0,0-.11.58v.16a1.65,1.65,0,0,1-.1.48,5.15,5.15,0,0,0,0,2.25,8.1,8.1,0,0,0,1.13,2.57,4.11,4.11,0,0,0,.39.54c.16.18.35.34.53.52a7.46,7.46,0,0,1,1,1.31c.08.13.2.28.35.26a.37.37,0,0,0,.21-.18,1.45,1.45,0,0,0,.34-.55,5.13,5.13,0,0,0,.13-.66s0-.07,0-.11a8.22,8.22,0,0,0-.41-3.37,8.83,8.83,0,0,0-.72-1.56A8.45,8.45,0,0,0,64.72,330.68Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.94,334.27a6.67,6.67,0,0,0-3.49.07,17.21,17.21,0,0,0-3.67,1.08,9.23,9.23,0,0,0-2,1.25A21.86,21.86,0,0,1,73,331.59a25.3,25.3,0,0,1,5.15-4.87c.07-.05.08-.32,0-.27a19.4,19.4,0,0,0-5.25,3.38A19.63,19.63,0,0,0,69,335a21.26,21.26,0,0,0-1.21,2.72c0-.18-.11-.36-.17-.54a9.62,9.62,0,0,0-.75-1.63,5.57,5.57,0,0,0-.52-.75c-.12-.15-.27-.42-.49-.39a.09.09,0,0,0-.06.11,2,2,0,0,0,.32.81c.12.22.24.44.35.67a11.3,11.3,0,0,1,.55,1.4c.17.5.25,1,.37,1.52a20.47,20.47,0,0,0-.49,2,26.5,26.5,0,0,0-.44,4c-.11-.28-.22-.57-.35-.84a11.24,11.24,0,0,0-1.36-2.12c-.1-.13-.2.17-.13.27a11.14,11.14,0,0,1,1.66,4.43c0,.28.1.55.14.82,0,.45,0,.9,0,1.35,0,1.64,0,3.27,0,4.91s-.22,3.12-.29,4.68c0,.24.39.72.57.36,1.12-2.25,1.12-5,1.14-7.46,0-1.52,0-3,0-4.56l.06-.05a3.92,3.92,0,0,1,.81-.36,11.51,11.51,0,0,0,1.72-.76,11.24,11.24,0,0,0,2.93-2.24c.05-.07,0-.28-.07-.18A6.7,6.7,0,0,1,70,344.9c-.64.17-1.27.36-1.9.55l-.29.1c0-.71.06-1.41.13-2.11a21.84,21.84,0,0,1,.66-3.64c.5-.52.88-1.2,1.39-1.7a9.53,9.53,0,0,1,2.36-1.67,16.46,16.46,0,0,1,3-1.12c.54-.16,1.09-.29,1.63-.44a4.68,4.68,0,0,1,1.87-.36C79,334.52,79,334.3,78.94,334.27Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-2--inject-52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Monitor--inject-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.68,396.31a11.17,11.17,0,0,0,10.08-.18L335.91,257.48a11.5,11.5,0,0,0,5.2-9V29.67a11.15,11.15,0,0,0-4.88-8.82,11.14,11.14,0,0,0-10.07.19L86,159.69a11.5,11.5,0,0,0-5.2,9V387.49A11.12,11.12,0,0,0,85.68,396.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.76,396.12,335.91,257.47a11.5,11.5,0,0,0,5.2-9V29.67c0-3.32-2.33-4.67-5.2-3L95.76,165.31a11.52,11.52,0,0,0-5.2,9v218.8C90.56,396.43,92.89,397.78,95.76,396.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.56,375.43v17.69c0,3.31,2.33,4.66,5.2,3L335.91,257.47a11.5,11.5,0,0,0,5.2-9V230.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.43,359V176.64a7.06,7.06,0,0,1,3.2-5.54L331,38.08c1.77-1,3.2-.2,3.2,1.84V222.26a7.06,7.06,0,0,1-3.2,5.54l-230.41,133C98.86,361.84,97.43,361,97.43,359Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.34,163.56l9.75,5.62a10.94,10.94,0,0,0-1.54,5.14v218.8c0,3,2,4.71,5.2,3a11,11,0,0,1-10.08.18,10,10,0,0,1-4.88-8.19V168.7A10.72,10.72,0,0,1,82.34,163.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.28,315.6,223,308.85c1.06-.61,1.91-.17,1.91,1A4.07,4.07,0,0,1,223,313l-11.76,6.75c-1.05.61-1.91.18-1.91-1A4.11,4.11,0,0,1,211.28,315.6Z",
    style: {
      fill: "#8E4DFE"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-1--inject-52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--hard-drive--inject-52"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "158.43 433.48 158.43 422.8 232.43 465.52 232.43 476.2 158.43 433.48",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.43 433.48 158.43 422.8 232.43 465.52 232.43 476.2 158.43 433.48",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.11 434.81 158.43 433.48 232.43 476.2 230.11 477.54 156.11 434.81",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.11 434.81 158.43 433.48 232.43 476.2 230.11 477.54 156.11 434.81",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.18,420V407a5.48,5.48,0,0,0-2.47-4.27l-55.85-32.25a36,36,0,0,0-36,0l-83.76,48.36v2.67l72.07,41.61a4.26,4.26,0,0,1,1.93,3.35v9.93c0,.65-.46.92-1,.59l-73-42.13v2.67L230,480.12a1.73,1.73,0,0,0,1.74.17h0l101.75-58.75h0A1.73,1.73,0,0,0,334.18,420Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.18,420V407a5.48,5.48,0,0,0-2.47-4.27l-55.85-32.25a36,36,0,0,0-36,0l-83.76,48.36v2.67l72.07,41.61a4.26,4.26,0,0,1,1.93,3.35v9.93c0,.65-.46.92-1,.59l-73-42.13v2.67L230,480.12a1.73,1.73,0,0,0,1.74.17h0l101.75-58.75h0A1.73,1.73,0,0,0,334.18,420Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.45,421.54h0a1.73,1.73,0,0,0,.73-1.59V407a5.05,5.05,0,0,0-.73-2.43l-103.9,60a4,4,0,0,1,.56,1.91v9.93c0,.65-.46.92-1,.59l-1.83-1.06-.18,2.57,2.89,1.67a1.73,1.73,0,0,0,1.74.17h0Z",
    style: {
      fill: "#8E4DFE",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.55,464.51a4.75,4.75,0,0,1,.46,1.16l101.85-60.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.18,463.07a4.26,4.26,0,0,1,1.93,3.35v9.93c0,.65-.46.92-1,.59l-73-42.13v2.67L230,480.12c1.36.78,2.47.14,2.47-1.42v-13a5.45,5.45,0,0,0-2.47-4.27l-73.85-42.64v2.67Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.18,463.07a4.26,4.26,0,0,1,1.93,3.35v9.93c0,.65-.46.92-1,.59l-73-42.13v2.67L230,480.12c1.36.78,2.47.14,2.47-1.42v-13a5.45,5.45,0,0,0-2.47-4.27l-73.85-42.64v2.67Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.6,419.5l5.7,3.3a2.75,2.75,0,0,0,2.47,0l2.16-1.25a.75.75,0,0,0,0-1.42l-5.71-3.3a2.73,2.73,0,0,0-2.46,0l-2.16,1.25A.75.75,0,0,0,166.6,419.5Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.6,419.5l5.7,3.3a2.75,2.75,0,0,0,2.47,0l2.16-1.25a.75.75,0,0,0,0-1.42l-5.71-3.3a2.73,2.73,0,0,0-2.46,0l-2.16,1.25A.75.75,0,0,0,166.6,419.5Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.93,420.79l-5.71-3.29a2.73,2.73,0,0,0-2.46,0l-2.16,1.25a1.09,1.09,0,0,0-.41.38,1.16,1.16,0,0,0,.41.37l5.7,3.3a2.75,2.75,0,0,0,2.47,0l2.16-1.25a.38.38,0,1,0,0-.76Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.5,421.45c-.29.17-.17.51.27.76a1.5,1.5,0,0,0,1.31.15c.29-.16.17-.5-.27-.75A1.48,1.48,0,0,0,172.5,421.45Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.06,419.49l3,1.75a1.13,1.13,0,0,0,1,0h0c.29-.17.32-.42.07-.57l-3-1.74a1,1,0,0,0-1,0h0C167.84,419.1,167.81,419.35,168.06,419.49Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.98 431.68 156.1 439.69 156.1 442.36 153.79 443.7 160.73 447.7 163.04 446.37 167.66 446.37 181.54 438.36 169.98 431.68",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.79 443.7 153.79 449.04 160.73 453.04 163.04 451.71 167.66 451.71 181.54 443.69 181.54 438.36 167.66 446.37 163.04 446.37 160.73 447.7 153.79 443.7",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.04 446.37 163.04 451.71 160.73 453.04 160.73 447.7 163.04 446.37",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.66 446.37 181.54 438.36 181.54 443.69 167.66 451.71 167.66 446.37",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.8,446.12l-1.66,1h0a1.3,1.3,0,0,0-.55,1.21,4.14,4.14,0,0,0,1.88,3.25,1.29,1.29,0,0,0,1.32.13h0l1.66-1a1.3,1.3,0,0,0,.55-1.21,4.17,4.17,0,0,0-1.87-3.25A1.34,1.34,0,0,0,155.8,446.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.59,448.29a4.14,4.14,0,0,0,1.88,3.25c1,.6,1.87.11,1.87-1.08a4.16,4.16,0,0,0-1.87-3.25C154.43,446.61,153.59,447.1,153.59,448.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.88,449.91a.47.47,0,0,1-.2.42l-8,4.65a9.79,9.79,0,0,1-9,0L87.07,425.2a3.36,3.36,0,0,1,0-6.26L128,395.37a8.92,8.92,0,0,0,.7,1.74L88,420.55c-.77.44-1.21,1-1.21,1.52s.44,1.08,1.21,1.52l51.58,29.79a8,8,0,0,0,7.14,0l8-4.65h0a.48.48,0,0,1,.47,0A1.47,1.47,0,0,1,155.88,449.91Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364,63.87l-6.57-3.81L128.14,192.51V398c0,2.23.78,3.79,2,4.53h0l6.56,3.82h0c1.26.73,3,.63,4.95-.49L357,281.48a15.47,15.47,0,0,0,7-12.12Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.57,406a5.66,5.66,0,0,0,2.72-.85L356.64,280.78a14.6,14.6,0,0,0,6.59-11.42V65.27L135.51,196.79v205C135.51,404.44,136.65,406,138.57,406Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.42,66.67V269.36a13.88,13.88,0,0,1-6.19,10.72L140.89,404.46a4.87,4.87,0,0,1-2.32.74c-2,0-2.26-2.36-2.26-3.38V197.26L362.42,66.67m1.62-2.8L134.7,196.33V401.82c0,3.17,1.57,5,3.87,5a6.38,6.38,0,0,0,3.13-1L357,281.48a15.47,15.47,0,0,0,7-12.12V63.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.7 196.33 134.7 218.2 364.03 85.74 364.04 63.87 134.7 196.33",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.7 196.33 134.7 218.2 364.03 85.74 364.04 63.87 134.7 196.33",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.14,116.18v4.5c0,.92.65,1.3,1.45.84l57.87-33.44V80.22l-57.87,33.44A3.21,3.21,0,0,0,289.14,116.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.08,75.82c.8-.46,1.45-.08,1.45.84v4.51a3.21,3.21,0,0,1-1.45,2.51l-7.62,4.4V80.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.26,82.47l-.88-.41a4.86,4.86,0,0,0,.31-1.16,2.16,2.16,0,0,0-.57-2.07,1.27,1.27,0,0,0-1.34-.12,4.7,4.7,0,0,0-2.35,3.55,2.19,2.19,0,0,0,.56,2.07,1.21,1.21,0,0,0,.56.24,1.61,1.61,0,0,0,.79-.12,3.93,3.93,0,0,0,1.75-1.77l.88.41.1,0a.34.34,0,0,0,.19-.65Zm-3.18,1.35a.65.65,0,0,1-.67,0,1.61,1.61,0,0,1-.3-1.43,4.12,4.12,0,0,1,1.93-3,.86.86,0,0,1,.43-.07.4.4,0,0,1,.23.1A1.6,1.6,0,0,1,354,80.8,4.15,4.15,0,0,1,352.08,83.82Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.49,49.3c-1.27-.78-3.05-.7-5,.44L135.13,174.12a15.46,15.46,0,0,0-7,12.12v6.27l6.56,3.82L364,63.87V57.6c0-2.22-.78-3.78-2-4.51S356.63,50,355.49,49.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.7,190.05a15.46,15.46,0,0,1,7-12.12L357,53.56c3.86-2.23,7-.42,7,4v6.27L134.7,196.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.08,53.13c-1.28-.79-3.06-.71-5,.43L141.7,177.93a14.24,14.24,0,0,0-4.95,5.22l-6.57-3.8a14.22,14.22,0,0,1,5-5.23L350.47,49.73c2-1.13,3.75-1.21,5-.43s5.35,3.1,6.53,3.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.6,68.47a5.39,5.39,0,0,0-2.44,4.23c0,1.56,1.09,2.19,2.44,1.41A5.39,5.39,0,0,0,342,69.88C342,68.32,341,67.69,339.6,68.47Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.15,63.54a5.41,5.41,0,0,0-2.44,4.24c0,1.56,1.09,2.19,2.44,1.41A5.41,5.41,0,0,0,350.59,65C350.59,63.4,349.5,62.77,348.15,63.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.7,58.62a5.39,5.39,0,0,0-2.44,4.23c0,1.56,1.09,2.19,2.44,1.41A5.4,5.4,0,0,0,359.15,60C359.15,58.47,358.05,57.84,356.7,58.62Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.1,404.69c-3.64,2.1-6.59.39-6.59-3.81V218.66l54.69-31.58V376.91Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.31,219.13l53.08-30.66v188L142.5,403.53c-3.35,1.93-6.19.3-6.19-3.58V219.13m-1.61-.93V401.82c0,4.46,3.13,6.27,7,4L191,377.38V185.67L134.7,218.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.7 196.33 128.14 192.51 128.14 214.41 134.7 218.2 134.7 196.33",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.7 196.33 128.14 192.51 128.14 214.41 134.7 218.2 134.7 196.33",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.7 196.33 128.14 192.51 128.14 214.41 134.7 218.2 134.7 196.33",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.77,218.82l24.33-14.06c.9-.52,1.63-.1,1.63.94v2.12a3.64,3.64,0,0,1-1.63,2.82L155.77,224.7c-.9.52-1.62.1-1.62-.94v-2.12A3.63,3.63,0,0,1,155.77,218.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.06,224.58v2.11a3.61,3.61,0,0,1-1.62,2.82l-1.84,1.06c-.89.52-1.62.1-1.62-.94v-2.12a3.6,3.6,0,0,1,1.62-2.81l1.84-1.06C148.33,223.12,149.06,223.54,149.06,224.58Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.77,230.52l24.33-14.06c.9-.52,1.63-.1,1.63.94v2.12a3.61,3.61,0,0,1-1.63,2.81L155.77,236.4c-.9.51-1.62.09-1.62-.94v-2.12A3.61,3.61,0,0,1,155.77,230.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.06,236.28v2.11a3.61,3.61,0,0,1-1.62,2.82l-1.84,1.06c-.89.52-1.62.1-1.62-.94v-2.12a3.6,3.6,0,0,1,1.62-2.81l1.84-1.06C148.33,234.82,149.06,235.24,149.06,236.28Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.77,242.22l24.33-14.06c.9-.52,1.63-.1,1.63.94v2.12A3.61,3.61,0,0,1,180.1,234L155.77,248.1c-.9.51-1.62.09-1.62-.94V245A3.61,3.61,0,0,1,155.77,242.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.06,248v2.11a3.61,3.61,0,0,1-1.62,2.82L145.6,254c-.89.52-1.62.1-1.62-.94v-2.12a3.58,3.58,0,0,1,1.62-2.81l1.84-1.06C148.33,246.52,149.06,246.94,149.06,248Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.77,281,180.1,267c.9-.52,1.63-.1,1.63.94V270a3.62,3.62,0,0,1-1.63,2.82l-24.33,14.06c-.9.52-1.62.1-1.62-.94v-2.11A3.61,3.61,0,0,1,155.77,281Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.06,286.77v2.12a3.6,3.6,0,0,1-1.62,2.81l-1.84,1.06c-.89.52-1.62.1-1.62-.94v-2.11a3.61,3.61,0,0,1,1.62-2.82l1.84-1.06C148.33,285.31,149.06,285.73,149.06,286.77Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.77,291.38l24.33-14.06c.9-.52,1.63-.1,1.63.94v2.11a3.62,3.62,0,0,1-1.63,2.82l-24.33,14.06c-.9.52-1.62.1-1.62-.94V294.2A3.61,3.61,0,0,1,155.77,291.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.06,297.13v2.12a3.61,3.61,0,0,1-1.62,2.82l-1.84,1.05c-.89.52-1.62.1-1.62-.93v-2.12a3.61,3.61,0,0,1,1.62-2.82l1.84-1.06C148.33,295.68,149.06,296.1,149.06,297.13Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.77,301.74l24.33-14.06c.9-.52,1.63-.1,1.63.94v2.12a3.62,3.62,0,0,1-1.63,2.81l-24.33,14.06c-.9.52-1.62.1-1.62-.93v-2.12A3.61,3.61,0,0,1,155.77,301.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.06,307.5v2.11a3.61,3.61,0,0,1-1.62,2.82l-1.84,1.06c-.89.51-1.62.09-1.62-.94v-2.12a3.61,3.61,0,0,1,1.62-2.82l1.84-1.05C148.33,306,149.06,306.46,149.06,307.5Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.15 254.99 154.15 258.64 157.31 254.99 154.15 254.99",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.23,254.24c0,.68.49.95,1.09.6l20.32-11.7a2.39,2.39,0,0,0,1.09-1.87c0-.69-.49-1-1.09-.62l-20.32,11.74A2.36,2.36,0,0,0,159.23,254.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.15 260.86 154.15 264.51 157.31 260.86 154.15 260.86",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.23,260.11c0,.68.49.95,1.09.6L180.64,249a2.39,2.39,0,0,0,1.09-1.87c0-.69-.49-1-1.09-.62l-20.32,11.74A2.36,2.36,0,0,0,159.23,260.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.15 266.73 154.15 270.38 157.31 266.73 154.15 266.73",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.23,266c0,.68.49.95,1.09.6l20.32-11.7a2.39,2.39,0,0,0,1.09-1.87c0-.69-.49-1-1.09-.62l-20.32,11.74A2.36,2.36,0,0,0,159.23,266Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.15 272.6 154.15 276.25 157.31 272.6 154.15 272.6",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.23,271.85c0,.68.49.95,1.09.6l20.32-11.7a2.39,2.39,0,0,0,1.09-1.87c0-.69-.49-1-1.09-.62L160.32,270A2.36,2.36,0,0,0,159.23,271.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.65, -0.38, 0, 1, 200.07, 201.82)",
    style: {
      fontSize: "17.165000915527344px",
      fill: "#455a64",
      fontFamily: "Rubik-Medium, Rubik",
      fontWeight: 500
    }
  }, " M", /*#__PURE__*/React.createElement("tspan", {
    x: 26.43,
    y: 0,
    style: {
      letterSpacing: "-0.025943051339844286em"
    }
  }, "y"), _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 36.1,
    y: 0,
    xmlSpace: "preserve"
  }, " Files"))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folders--inject-52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folder--inject-52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--folder--inject-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.77,306.69a1.33,1.33,0,0,1-.64-.17,1.27,1.27,0,0,1-.64-1.11v-52.9a3,3,0,0,1,.44-1.51,3.21,3.21,0,0,1,1.08-1.14l15.58-9a1.62,1.62,0,0,1,1.66-.05,1.71,1.71,0,0,1,.8,1l1.26,4.2a.57.57,0,0,0,.91.36L337,226.92a1.45,1.45,0,0,1,1.31-.14l.17.09a1.42,1.42,0,0,1,.59,1.24v44.52a3.34,3.34,0,0,1-1.53,2.65l-54.1,31.24A1.33,1.33,0,0,1,282.77,306.69Zm16.71-65a.68.68,0,0,0-.36.11l-15.57,9a2.18,2.18,0,0,0-.71.76,2,2,0,0,0-.29,1v52.9a.21.21,0,0,0,.11.19.19.19,0,0,0,.22,0L337,274.36a2.27,2.27,0,0,0,1-1.73V228.11a.5.5,0,0,0-.09-.34l-.07,0a.76.76,0,0,0-.32.11l-33.75,19.48a1.71,1.71,0,0,1-1.47.14,1.68,1.68,0,0,1-1-1.12l-1.26-4.2a.7.7,0,0,0-.29-.39A.52.52,0,0,0,299.48,241.68Z",
    style: {
      fill: "#8E4DFE"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--folder--inject-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.47,284.34l-.41-.24-.48-.28-.42-.24a3.06,3.06,0,0,1-1.33-2L347.16,239a1.87,1.87,0,0,0-.84-1.44l-.72-.41a1.78,1.78,0,0,0-1.82.12l-29.13,16.62a2.67,2.67,0,0,1-2.2.21,2.6,2.6,0,0,1-.56-.67l-.95-1.64a2.58,2.58,0,0,0-1-1l-.73-.42a2.66,2.66,0,0,0-2.66,0l-13.46,7.77a4.32,4.32,0,0,0-2,4L297.93,313a3.71,3.71,0,0,0,1.66,2.47l1.3.75a1.65,1.65,0,0,0,.81.25,1.32,1.32,0,0,0,.66-.16l53.93-31.89A.83.83,0,0,1,355.47,284.34Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.47,284.34l-1.31-.76a3.1,3.1,0,0,1-1.33-2L347.16,239a1.66,1.66,0,0,0-2.67-1.31l-28.95,16.71a2.67,2.67,0,0,1-3.65-1l-.95-1.64a2.67,2.67,0,0,0-3.65-1l-13.45,7.77a4.29,4.29,0,0,0-2,4l6.7,50.32a3.08,3.08,0,0,0,1.34,2l1.3.76a.83.83,0,0,0,.82.08l54.25-31.32A.83.83,0,0,1,355.47,284.34Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.92,314.9l1.3.76a.83.83,0,0,0,.82.08l54.25-31.32a.83.83,0,0,1-.82-.08l-1.31-.76a2.82,2.82,0,0,1-.85-.84l-54.25,31.32A2.74,2.74,0,0,0,299.92,314.9Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.23,266.57v44.17a.69.69,0,0,0,.3.53l.34.19a.66.66,0,0,0,.61,0l48.94-28.25a.66.66,0,0,0,.3-.53V238.51a.65.65,0,0,0-.3-.52l-.34-.2a.66.66,0,0,0-.61,0l-48.94,28.26A.67.67,0,0,0,300.23,266.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.71,238.43a.23.23,0,0,0,0-.11l0,0a.86.86,0,0,0-.1-.16.3.3,0,0,0-.08-.08l-.06,0-.34-.2a.64.64,0,0,0-.6,0l-48.94,28.26a.52.52,0,0,0-.22.22l.95.55a.59.59,0,0,1,.21-.23l48.94-28.25C350.56,238.25,350.68,238.3,350.71,238.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.39,311.5c-.12,0-.21-.05-.21-.21V267.11a.63.63,0,0,1,.08-.29l-.94-.55a.69.69,0,0,0-.09.3v44.17a.69.69,0,0,0,.3.53l.34.19A.67.67,0,0,0,301.39,311.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M301.39,311.5c-.12,0-.21-.05-.21-.21V267.11a.63.63,0,0,1,.08-.29l-.94-.55a.69.69,0,0,0-.09.3v44.17a.69.69,0,0,0,.3.53l.34.19A.67.67,0,0,0,301.39,311.5Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M357.28,242.12a1.64,1.64,0,0,0-.67-1.5l-.67-.38a1.62,1.62,0,0,0-1.63.16l-49.62,28.65a5.11,5.11,0,0,0-2.31,4V315a.81.81,0,0,1-.34.75l.32.57,54.58-31.51a.82.82,0,0,0,.34-.75Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.36,316.31A1.43,1.43,0,0,0,303,315V273.44a5.12,5.12,0,0,1,2.32-4L355,240.78c1.27-.74,2.31-.14,2.31,1.34v41.93a.82.82,0,0,1-.34.75Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M324,271v18.78l-3.3,3.23a7.09,7.09,0,0,0-2,4.76c0,2.07,1.26,3,2.81,2.13l1.38-.79a6.75,6.75,0,0,0,2.82-5.39v-2.62l0,0V276.83l11.47-11.68v12.79L334,281.13a7.16,7.16,0,0,0-2,4.77h0c0,2.07,1.26,3,2.82,2.13l1.38-.8a6.76,6.76,0,0,0,2.81-5.38v-26Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--folder--inject-52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--folder--inject-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.22,354.35a1.23,1.23,0,0,1-.64-.17,1.27,1.27,0,0,1-.64-1.11v-52.9a3,3,0,0,1,.44-1.51,3.21,3.21,0,0,1,1.08-1.14l15.58-9a1.62,1.62,0,0,1,1.66,0,1.71,1.71,0,0,1,.8,1l1.26,4.2a.63.63,0,0,0,.36.44.62.62,0,0,0,.55-.08l33.75-19.47a1.43,1.43,0,0,1,1.31-.15l.17.09a1.43,1.43,0,0,1,.59,1.24v44.52a3.32,3.32,0,0,1-1.53,2.65l-54.1,31.24A1.23,1.23,0,0,1,200.22,354.35Zm16.71-65a.78.78,0,0,0-.36.11l-15.57,9a2.06,2.06,0,0,0-.71.75,2,2,0,0,0-.29,1v52.9a.21.21,0,0,0,.11.19.19.19,0,0,0,.22,0L254.43,322a2.3,2.3,0,0,0,1-1.74V275.77a.5.5,0,0,0-.09-.34l-.07,0a.76.76,0,0,0-.32.11L221.2,295a1.63,1.63,0,0,1-2.45-1l-1.26-4.2a.72.72,0,0,0-.29-.4A.54.54,0,0,0,216.93,289.34Z",
    style: {
      fill: "#8E4DFE"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--folder--inject-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.92,332.32l-.41-.24-.48-.28-.42-.24a3.06,3.06,0,0,1-1.33-2L264.61,287a1.83,1.83,0,0,0-.84-1.43l-.72-.42a1.82,1.82,0,0,0-1.82.12L232.1,301.9a2.67,2.67,0,0,1-2.2.21,2.6,2.6,0,0,1-.56-.67l-1-1.64a2.58,2.58,0,0,0-1-1l-.73-.42a2.66,2.66,0,0,0-2.66,0l-13.46,7.77a4.32,4.32,0,0,0-2,4L215.38,361a3.71,3.71,0,0,0,1.66,2.47l1.3.76a1.76,1.76,0,0,0,.81.24,1.22,1.22,0,0,0,.66-.16l53.93-31.89A.83.83,0,0,1,272.92,332.32Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.92,332.32l-1.31-.76a3.08,3.08,0,0,1-1.33-2L264.61,287a1.66,1.66,0,0,0-2.67-1.31L233,302.42a2.68,2.68,0,0,1-3.65-1l-1-1.64a2.68,2.68,0,0,0-3.65-1l-13.45,7.77a4.3,4.3,0,0,0-2,4l6.7,50.31a3.05,3.05,0,0,0,1.34,2l1.3.76a.83.83,0,0,0,.82.08l54.25-31.32A.83.83,0,0,1,272.92,332.32Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.37,362.88l1.3.76a.83.83,0,0,0,.82.08l54.25-31.32a.83.83,0,0,1-.82-.08l-1.31-.76a2.82,2.82,0,0,1-.85-.84L216.51,362A2.74,2.74,0,0,0,217.37,362.88Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.68,314.55v44.17a.69.69,0,0,0,.3.53l.34.19a.66.66,0,0,0,.61,0l48.94-28.25a.66.66,0,0,0,.3-.52V286.49a.65.65,0,0,0-.3-.52l-.34-.2a.66.66,0,0,0-.61,0L218,314A.67.67,0,0,0,217.68,314.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.16,286.41a.26.26,0,0,0,0-.11l0-.05a.86.86,0,0,0-.1-.16l-.08-.08-.06,0-.34-.2a.64.64,0,0,0-.6,0L218,314a.58.58,0,0,0-.22.22l.95.55a.59.59,0,0,1,.21-.23l48.94-28.25C268,286.23,268.13,286.28,268.16,286.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.84,359.48c-.12,0-.21-.05-.21-.21V315.1a.64.64,0,0,1,.08-.3l-.94-.55a.69.69,0,0,0-.09.3v44.17a.69.69,0,0,0,.3.53l.34.19A.63.63,0,0,0,218.84,359.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M218.84,359.48c-.12,0-.21-.05-.21-.21V315.1a.64.64,0,0,1,.08-.3l-.94-.55a.69.69,0,0,0-.09.3v44.17a.69.69,0,0,0,.3.53l.34.19A.63.63,0,0,0,218.84,359.48Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M274.73,290.1a1.65,1.65,0,0,0-.67-1.5l-.67-.38a1.64,1.64,0,0,0-1.63.16L222.14,317a5.11,5.11,0,0,0-2.31,4V363a.81.81,0,0,1-.34.75l.32.57,54.58-31.51a.81.81,0,0,0,.34-.75Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.81,364.29a1.43,1.43,0,0,0,.67-1.32V321.42a5.12,5.12,0,0,1,2.32-4l49.62-28.65c1.27-.74,2.31-.14,2.31,1.34V332a.81.81,0,0,1-.34.75Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M247.11,342.45c-6.8,3.92-12.33-.26-12.33-9.32s5.53-19.63,12.33-23.56,12.33.26,12.33,9.32S253.91,338.52,247.11,342.45Zm0-29.58c-5.44,3.14-9.86,11.58-9.86,18.83s4.42,10.59,9.86,7.45S257,327.56,257,320.32,252.54,309.73,247.11,312.87Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.07,333.58V323.1c0-.78.62-1.65,1.14-1.6l7.86.7c.58.05.58,1.16,0,1.89l-7.86,9.77C243.69,334.52,243.07,334.36,243.07,333.58Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--folder--inject-52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--folder--inject-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.77,221.24a1.33,1.33,0,0,1-.64-.17,1.29,1.29,0,0,1-.64-1.12V167.06a3,3,0,0,1,.44-1.51,3.21,3.21,0,0,1,1.08-1.14l15.58-9a1.65,1.65,0,0,1,1.66-.06,1.76,1.76,0,0,1,.8,1l1.26,4.2a.58.58,0,0,0,.91.36L337,141.47a1.42,1.42,0,0,1,1.31-.14l.17.08a1.45,1.45,0,0,1,.59,1.25v44.52a3.34,3.34,0,0,1-1.53,2.65l-54.1,31.24A1.33,1.33,0,0,1,282.77,221.24Zm16.71-65a.76.76,0,0,0-.36.1l-15.57,9a2.1,2.1,0,0,0-.71.76,2,2,0,0,0-.29,1V220a.22.22,0,0,0,.11.2.24.24,0,0,0,.22,0L337,188.91a2.28,2.28,0,0,0,1-1.73V142.66a.56.56,0,0,0-.09-.35l-.07,0a.76.76,0,0,0-.32.11l-33.75,19.48a1.71,1.71,0,0,1-1.47.14,1.68,1.68,0,0,1-1-1.12l-1.26-4.2a.67.67,0,0,0-.29-.39A.52.52,0,0,0,299.48,156.23Z",
    style: {
      fill: "#8E4DFE"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--folder--inject-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.47,199.2l-.41-.23-.48-.28-.42-.24a3.06,3.06,0,0,1-1.33-2l-5.67-42.56a1.87,1.87,0,0,0-.84-1.44l-.72-.42a1.8,1.8,0,0,0-1.82.13l-29.13,16.62a2.67,2.67,0,0,1-2.2.21,2.6,2.6,0,0,1-.56-.67l-.95-1.64a2.68,2.68,0,0,0-1-1l-.73-.41a2.64,2.64,0,0,0-2.66,0l-13.46,7.77a4.31,4.31,0,0,0-2,4l6.77,50.82a3.73,3.73,0,0,0,1.66,2.47l1.3.75a1.65,1.65,0,0,0,.81.25,1.2,1.2,0,0,0,.66-.17l53.93-31.89A.78.78,0,0,1,355.47,199.2Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.47,199.2l-1.31-.75a3.1,3.1,0,0,1-1.33-2l-5.67-42.56a1.66,1.66,0,0,0-2.67-1.32L315.54,169.3a2.67,2.67,0,0,1-3.65-1l-.95-1.64a2.67,2.67,0,0,0-3.65-1l-13.45,7.77a4.29,4.29,0,0,0-2,4l6.7,50.32a3.08,3.08,0,0,0,1.34,2l1.3.75a.81.81,0,0,0,.82.09l54.25-31.33A.78.78,0,0,1,355.47,199.2Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.92,229.77l1.3.75a.81.81,0,0,0,.82.09l54.25-31.33a.78.78,0,0,1-.82-.08l-1.31-.75a2.82,2.82,0,0,1-.85-.84l-54.25,31.32A2.74,2.74,0,0,0,299.92,229.77Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.23,181.44v44.17a.67.67,0,0,0,.3.52l.34.2a.66.66,0,0,0,.61,0l48.94-28.25a.68.68,0,0,0,.3-.53V153.38a.68.68,0,0,0-.3-.53l-.34-.19a.66.66,0,0,0-.61,0l-48.94,28.25A.69.69,0,0,0,300.23,181.44Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.71,153.3a.23.23,0,0,0,0-.11l0-.06a1.3,1.3,0,0,0-.1-.15.3.3,0,0,0-.08-.08l-.06-.05-.34-.19a.64.64,0,0,0-.6,0l-48.94,28.25a.54.54,0,0,0-.22.23l.95.54a.63.63,0,0,1,.21-.22l48.94-28.26C350.56,153.12,350.68,153.16,350.71,153.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.39,226.37c-.12,0-.21-.05-.21-.21V182a.71.71,0,0,1,.08-.3l-.94-.54a.65.65,0,0,0-.09.3v44.17a.67.67,0,0,0,.3.52l.34.2A.67.67,0,0,0,301.39,226.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M301.39,226.37c-.12,0-.21-.05-.21-.21V182a.71.71,0,0,1,.08-.3l-.94-.54a.65.65,0,0,0-.09.3v44.17a.67.67,0,0,0,.3.52l.34.2A.67.67,0,0,0,301.39,226.37Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M357.28,157a1.63,1.63,0,0,0-.67-1.49l-.67-.38a1.62,1.62,0,0,0-1.63.16l-49.62,28.65a5.11,5.11,0,0,0-2.31,4v41.93a.82.82,0,0,1-.34.75l.32.56,54.58-31.51a.8.8,0,0,0,.34-.74Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.36,231.17a1.4,1.4,0,0,0,.67-1.31V188.31a5.12,5.12,0,0,1,2.32-4L355,155.65c1.27-.74,2.31-.14,2.31,1.33v41.94a.8.8,0,0,1-.34.74Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Contact--inject-52",
    d: "M329.82,191.35c2.88-1.66,5.22-6.13,5.22-10s-2.34-5.61-5.22-3.94-5.22,6.12-5.22,10S326.94,193,329.82,191.35Zm8.78,2.31c-.35-2.56-2.15-3.54-4.25-2.33l-9.06,5.24c-2.1,1.21-3.89,4.26-4.25,7.22l-.62,5.28c-.06.5.2.76.56.56l17.69-10.21a1.36,1.36,0,0,0,.56-1.21Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--folder--inject-52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--folder--inject-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.22,268.9a1.23,1.23,0,0,1-.64-.17,1.27,1.27,0,0,1-.64-1.11v-52.9a3,3,0,0,1,.44-1.51,3.21,3.21,0,0,1,1.08-1.14l15.58-9a1.62,1.62,0,0,1,1.66-.05,1.71,1.71,0,0,1,.8,1l1.26,4.2a.63.63,0,0,0,.36.44.62.62,0,0,0,.55-.08l33.75-19.47a1.43,1.43,0,0,1,1.31-.15l.17.09a1.42,1.42,0,0,1,.59,1.24v44.52a3.32,3.32,0,0,1-1.53,2.65l-54.1,31.24A1.23,1.23,0,0,1,200.22,268.9Zm16.71-65a.78.78,0,0,0-.36.11L201,213a2.06,2.06,0,0,0-.71.75,2,2,0,0,0-.29,1v52.9a.21.21,0,0,0,.11.19.19.19,0,0,0,.22,0l54.1-31.24a2.27,2.27,0,0,0,1-1.73V190.32a.5.5,0,0,0-.09-.34l-.07,0a.76.76,0,0,0-.32.11L221.2,209.53a1.71,1.71,0,0,1-1.47.14,1.66,1.66,0,0,1-1-1.11l-1.26-4.2a.72.72,0,0,0-.29-.4A.54.54,0,0,0,216.93,203.89Z",
    style: {
      fill: "#8E4DFE"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--folder--inject-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.92,246.55l-.41-.24L272,246l-.42-.24a3.06,3.06,0,0,1-1.33-2l-5.67-42.56a1.83,1.83,0,0,0-.84-1.43l-.72-.42a1.82,1.82,0,0,0-1.82.12L232.1,216.13a2.64,2.64,0,0,1-2.2.21,2.6,2.6,0,0,1-.56-.67l-1-1.64a2.58,2.58,0,0,0-1-1l-.73-.42a2.66,2.66,0,0,0-2.66,0l-13.46,7.77a4.32,4.32,0,0,0-2,4l6.77,50.82a3.71,3.71,0,0,0,1.66,2.47l1.3.76a1.76,1.76,0,0,0,.81.24,1.22,1.22,0,0,0,.66-.16l53.93-31.89A.83.83,0,0,1,272.92,246.55Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.92,246.55l-1.31-.76a3.08,3.08,0,0,1-1.33-2l-5.67-42.56a1.66,1.66,0,0,0-2.67-1.31L233,216.65a2.68,2.68,0,0,1-3.65-1l-1-1.64a2.68,2.68,0,0,0-3.65-1l-13.45,7.77a4.3,4.3,0,0,0-2,4l6.7,50.31a3.05,3.05,0,0,0,1.34,2l1.3.76a.83.83,0,0,0,.82.08l54.25-31.32A.83.83,0,0,1,272.92,246.55Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.37,277.11l1.3.76a.83.83,0,0,0,.82.08l54.25-31.32a.83.83,0,0,1-.82-.08l-1.31-.76a2.82,2.82,0,0,1-.85-.84l-54.25,31.32A2.64,2.64,0,0,0,217.37,277.11Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.68,228.78V273a.69.69,0,0,0,.3.53l.34.19a.66.66,0,0,0,.61,0l48.94-28.25a.66.66,0,0,0,.3-.52V200.72a.65.65,0,0,0-.3-.52l-.34-.2a.66.66,0,0,0-.61,0L218,228.26A.67.67,0,0,0,217.68,228.78Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.16,200.64a.26.26,0,0,0,0-.11l0-.05a.86.86,0,0,0-.1-.16.3.3,0,0,0-.08-.08l-.06,0-.34-.2a.67.67,0,0,0-.6,0L218,228.26a.58.58,0,0,0-.22.22l.95.55a.59.59,0,0,1,.21-.23l48.94-28.25C268,200.46,268.13,200.51,268.16,200.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.84,273.71c-.12,0-.21,0-.21-.21V229.33a.64.64,0,0,1,.08-.3l-.94-.55a.69.69,0,0,0-.09.3V273a.69.69,0,0,0,.3.52l.34.2A.67.67,0,0,0,218.84,273.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M218.84,273.71c-.12,0-.21,0-.21-.21V229.33a.64.64,0,0,1,.08-.3l-.94-.55a.69.69,0,0,0-.09.3V273a.69.69,0,0,0,.3.52l.34.2A.67.67,0,0,0,218.84,273.71Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M274.73,204.33a1.65,1.65,0,0,0-.67-1.5l-.67-.38a1.64,1.64,0,0,0-1.63.16l-49.62,28.65a5.11,5.11,0,0,0-2.31,4V277.2a.81.81,0,0,1-.34.75l.32.57L274.39,247a.81.81,0,0,0,.34-.75Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.81,278.52a1.43,1.43,0,0,0,.67-1.32V235.65a5.12,5.12,0,0,1,2.32-4L272.42,203c1.27-.73,2.31-.14,2.31,1.34v41.93a.81.81,0,0,1-.34.75Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M259,239.91l-5.5-4.66c-.35-.29-.94,0-1.3.73l-2,3.84c-.35.68-.93,1-1.28.75L244.19,237c-.35-.27-.93.07-1.28.75l-7.33,14.1v4.85L259,243.23ZM256.17,232a5,5,0,0,0,2.1-4c0-1.55-.94-2.26-2.1-1.59a5,5,0,0,0-2.1,4C254.07,232,255,232.71,256.17,232Zm5.45-14.44-28.7,16.59a3.16,3.16,0,0,0-1.32,2.52v25.9c0,1,.59,1.42,1.32,1L261.62,247a3.16,3.16,0,0,0,1.32-2.52v-25.9C262.94,217.62,262.35,217.17,261.62,217.59Zm-1,26.75-26.71,15.44V236.85l26.71-15.43Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.33,187.17c7.73,1.83,11.91,4,15.09,14.47,3,9.93,8,26.71,9.36,33.82.65,3.47.94,6.77-3.88,8.81-10.89,4.6-21.39,7.83-21.39,7.83l-4.26-12.86,11.65-5.81-2.9-9.37Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.9,233.43a11,11,0,0,0,4.8,5.24c-2.84.35-5.61-2.62-6.33-4.48Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--folder--inject-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.44,271.59l.41-.23.48-.28.41-.24a3,3,0,0,0,1.33-2l5.68-42.56a1.87,1.87,0,0,1,.84-1.44l.72-.41a1.78,1.78,0,0,1,1.82.12l29.13,16.62a2.67,2.67,0,0,0,2.2.21,2.6,2.6,0,0,0,.56-.67l.94-1.64a2.6,2.6,0,0,1,1-1l.72-.42a2.65,2.65,0,0,1,2.67,0l13.45,7.77a4.28,4.28,0,0,1,2,4L477,300.26a3.71,3.71,0,0,1-1.65,2.47l-1.3.75a1.72,1.72,0,0,1-.81.25,1.36,1.36,0,0,1-.67-.16l-53.92-31.9A.78.78,0,0,0,419.44,271.59Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.44,271.59l1.3-.75a3,3,0,0,0,1.33-2l5.68-42.56a1.65,1.65,0,0,1,2.66-1.31l29,16.71a2.67,2.67,0,0,0,3.65-1l.94-1.64a2.67,2.67,0,0,1,3.65-1l13.46,7.77a4.32,4.32,0,0,1,2,4l-6.71,50.32a3,3,0,0,1-1.33,2l-1.3.75a.81.81,0,0,1-.82.09l-54.25-31.33A.78.78,0,0,0,419.44,271.59Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475,302.16l-1.3.75a.81.81,0,0,1-.82.09l-54.25-31.33a.78.78,0,0,0,.82-.08l1.3-.75a2.74,2.74,0,0,0,.86-.84l54.25,31.32A2.85,2.85,0,0,1,475,302.16Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.68,253.83V298a.68.68,0,0,1-.3.53l-.34.19a.64.64,0,0,1-.6,0l-48.94-28.25a.66.66,0,0,1-.3-.53V225.77a.65.65,0,0,1,.3-.52l.34-.2a.64.64,0,0,1,.6,0l48.94,28.25A.69.69,0,0,1,474.68,253.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.19,225.69l0-.11,0-.06a1.19,1.19,0,0,1,.09-.15l.09-.08.06,0,.34-.2a.64.64,0,0,1,.6,0l48.94,28.25a.52.52,0,0,1,.21.23l-.94.55a.59.59,0,0,0-.21-.23l-48.94-28.26C424.34,225.51,424.23,225.56,424.19,225.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.51,298.76c.13,0,.22-.05.22-.21V254.37a.55.55,0,0,0-.09-.29l.95-.55a.54.54,0,0,1,.08.3V298a.62.62,0,0,1-.3.52l-.34.2A.67.67,0,0,1,473.51,298.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M473.51,298.76c.13,0,.22-.05.22-.21V254.37a.55.55,0,0,0-.09-.29l.95-.55a.54.54,0,0,1,.08.3V298a.62.62,0,0,1-.3.52l-.34.2A.67.67,0,0,1,473.51,298.76Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M417.63,229.38a1.62,1.62,0,0,1,.67-1.5l.67-.38a1.62,1.62,0,0,1,1.63.16l49.62,28.65a5.11,5.11,0,0,1,2.31,4v41.93a.81.81,0,0,0,.34.75l-.33.57L418,272.05a.8.8,0,0,1-.33-.74Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.54,303.57a1.45,1.45,0,0,1-.67-1.32V260.7a5.11,5.11,0,0,0-2.31-4L419.94,228c-1.28-.74-2.31-.14-2.31,1.34v41.93a.8.8,0,0,0,.33.74Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Fingers--inject-52",
    d: "M461.69,297.3a2.42,2.42,0,0,1-.55.4,3,3,0,0,1-1.41.33,5.37,5.37,0,0,1-1.44-.19,1.35,1.35,0,0,1-.34-.11l-.4-.19a3.54,3.54,0,0,0-.85-.22,4.52,4.52,0,0,1-.63-.08,2.1,2.1,0,0,1-1.11-.79c-.29-.36-.51-.77-.77-1.15a1.85,1.85,0,0,0-.36-.42,2.88,2.88,0,0,0-1-.33,2.89,2.89,0,0,1-.76-.34,3,3,0,0,1-1-1.06,1.06,1.06,0,0,1-.16-.34,1.72,1.72,0,0,0-.11-.29c-.1-.2-.19-.4-.29-.61-.5-1.09-1-2.16-1.57-3.23-.47-.9-.85-1.63-.65-2.05.56-1.16,1.8-.25,2.21.19a16.7,16.7,0,0,1,2.31,3s-.23-.89-.1-1.12c.33-.6,1.43-.68,2.25.69,1.41,2.36,1.8,3.15,1.8,3.15s-.12-.64.34-.82a1.83,1.83,0,0,1,2,.9,33.57,33.57,0,0,1,1.55,4Z",
    style: {
      fill: "#ffbda7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.87,396.37c-2.88-1.81-5.62-2.29-7.32-6.23-.51-1.17-1-2.38-1.47-3.53h0c-1.91-6.24-6.19-23.14-8.22-29.21-3.35-10-5.91-12.24-9.62-17.41,0,0-.65-32-.8-52-.05-6.15,1.84-14,1.59-18-1.08-17.43-8.28-18.78-12-31.49l-40.25,3.65s-8.42,23.27-8.36,58.33c0,19.08.43,24.32,1.2,38.92.34,6.52,1.16,16.94,2.06,28.8.75,9.88,3.85,35.47,3.85,35.47l.33.1.6,7.68c.28,4.09.43,12.15-.59,17.11s-2.64,9.06-7,9.63c2.37,1.3,10.7,6.79,13.66.61a37.91,37.91,0,0,0,1.42-3.77c.48-1.36,1-2.71,1.45-4.07a23.91,23.91,0,0,1,2.83-6.08,17.74,17.74,0,0,1,2.32-2.58,6.82,6.82,0,0,0,1.06-1.09c.23-.35.53-.65.74-1a6.1,6.1,0,0,0,.74-3.08c0-1.74-2.13-2.92-2.3-7.34a41.9,41.9,0,0,1,.33-5.6,1,1,0,0,0,.18-.1s1.82-8.86,4-25a142.72,142.72,0,0,0,1.36-18.72,104.51,104.51,0,0,0-2.34-14.73l3.84-23.05,4.16,18.58c1.56,7,2.14,9.08,8.2,19.7,8.15,14.29,23.74,35.75,23.94,36,2.62,4,5.93,9.49,6.46,11,.63,1.83,1.31,8.68.2,10.74-1.6,1.26-4.16,2-6.32,3.17-3.13,1.67-3.76,4.35-1.66,6.35,2.94,2.79,7.59,3,10.4,2.8,4.07-.72,4.26-5.43,4.77-9.62S466,409,469,403.88s7-4.58,7.7-2.92C476.34,398.43,474.84,397.61,472.87,396.37Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.2,322.57l3.92-32.08s11.66-1.92,13.07-13.24c.4,6.69-2.09,12.51-9.29,15.75l-5.26,29.64,1.72,18.51Z",
    style: {
      fill: "#f0997a"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M393.52,447.69s1.32,2.09,7.81-1,8.19-6.49,8.19-6.49-2.36-13.2-6.29-9.66S393.52,447.69,393.52,447.69Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M409.81,414.06c-1.38-.65-4.91,1-6.94,2.93-2.66,2.53-3.18,5.8-4.43,9.68-1.32,4.13-3.81,9.84-6,11.19-1.23.77-2.34.44-3.75-.16A5.65,5.65,0,0,0,390,437c-1.4-.11-3.28-.57-4.49-.72-4.53-.57-7.52,1.52-7.59,4,0,1.93,7.91,8.39,13.44,8.36,4.6,0,6.19.67,8.41-6.16s3-10.65,5.23-6.18,3.56,14.68,3.56,14.68a3.41,3.41,0,0,0,3.76-.18s-.08-6.54.3-10.69,2.26-10.74,1.74-15.7S411.18,414.67,409.81,414.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.62,431.13c2.95.45,5,.4,10.16-2.33,4.45-2.36,5.58-3.34,6.24-4.61,1.05-2-.22-6.91.65-11.16a44.69,44.69,0,0,1,2.8-8.71s-.3-3.18-.48-3.93c-.38-1.6-2.39-2.26-5.37-.39s-4.89,5.35-5.73,13.57S466.75,430.75,457.62,431.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.08,401c-.38-2.53-.73-3.24-3.71-4.9-1.11-.61-2.16-1.64-3.17-2.14h0c-2.86-.5-6.76,1.75-6.87,7.92s1.06,14-.69,16.88c-1.49,2.5-4,2.38-3.48-.07-4,1.6-5.4,1.65-7.65,3-2.61,1.54-3.42,5.43-1,6.93a15.2,15.2,0,0,0,11,2.41c4.07-.72,4.26-5.43,4.77-9.62S466,409,469,403.88,476.34,399.3,477.08,401Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.28,408.85c.93-4.2,3.45-3.4,5.23-.2a104.77,104.77,0,0,1,5,11.24c.24,1,3.39-1.69,3.37-2.86a55.39,55.39,0,0,1-2.12-9.18c-.83-5.47-1.17-8.91-3.06-10.19C472.57,397.29,465.26,398.68,467.28,408.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.92,417a.63.63,0,0,0-.82-.38c-1.28.26-2.12,1.44-2.55,3.24l.08.14c.57.52,3.32-.66,3.3-1.76A6.47,6.47,0,0,0,480.92,417Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.47,284.26c2.69-22.75,4.95-30.45,6.92-43.06,0,0-.51-9.43-.9-13.71-5.15-5.06-6.23-12-3.34-18.8,3.64-8.61,6.59-15.13,12.18-16.73a93.2,93.2,0,0,1,10.88-2.43s9.55,1.42,15.1.72c8.61-1.07,8-3.28,7.94-4.2,0,0,1.87.31,4.87.85,1.88.33,6.1,2,7.7,9.81,3.46,16.84-7.27,34.08-7.78,43.94,3.83,10.08,6.94,14.4,8.46,23.38,1.37,8.05-.27,19.91.36,27.26s2.84,35.13,2.84,35.13-6.53,6-26,8.87-28.54,1.2-28.54,1.2l-1.91-25.69L391,336s-6.31-1.06-9.39-3.68C381.65,332.32,383.64,299.8,385.47,284.26Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.83,148.74c-1.35-1.81-1.16-4.5-.19-6.53s2.83-4.13,8-6.35c6.14-2.65,22.92-4.41,29.35,6.82,1,1.68-16.58,31.36-16.23,37.67-3.85-4.67-16.48-21-16.48-21-3.16-1.62-5-2.93-5.51-6.05A7.6,7.6,0,0,1,401.83,148.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.67,157.43s-4.9,6.87-4.46,7.49a22.35,22.35,0,0,0,3.1,2.38Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.05,144.74c-3,1.18-6.88,3.19-7.13,9.67-.07,1.71.79,4.07,0,6.28-3.24,9.44-.77,17.69,1,19.59,1.18,1.29,7.75,2.29,11.29,1.57,4.42-.9,14.15-4.49,19.13-11,5.86-7.6,7.86-18.25,2.27-23C428.77,141.26,413.3,143.48,410.05,144.74Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.54,183.19h0l-.41-7.06-17.67,3.12.39,3.95c.21,2.22.42,5.53-3,6.45-3.23.86-8.46,1.4-13.56,3.3,0,0,18.37,2.9,28,1.31s11.3-7.79,11.3-7.79C433.12,186,431.67,185.43,431.54,183.19Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.26,180.55c1.48,1,4.82,1.83,9.48,1.52l-.21-2.4a25.1,25.1,0,0,1-4.48,1A16.5,16.5,0,0,1,404.26,180.55Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.56,142.21c-.52-.19-9.46-2.45-14.44-1.73-8.73,1.25-13.22,3.25-15.49,4.87l-1.19-.09c-2.4,3.07-2.77,6.82-2.18,11.51a7.75,7.75,0,0,0,3.95,1.52,6,6,0,0,0,0,1.13c.27,2.15.95,4,3,4.8,1.25.52,1.67,0,2.2-1,.75-1.39,1.72-3.53,4.77-2.89,3.5.74,4.05,6.12,1.75,9.46a5.22,5.22,0,0,1-4.18,2.4,3.24,3.24,0,0,1-2.32-1.31s-.1,4.67,5.68,7.84c0,0,5.78,3.82,12.09,2.44a118.32,118.32,0,0,0,8.55-9.12C446.94,163.1,448.44,146.09,437.56,142.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.82,196.71c-1.6-7.78-5.82-9.48-7.7-9.81-3-.54-4.87-.85-4.87-.85.06.92.67,3.13-7.94,4.2-5.55.7-15.1-.72-15.1-.72A93.2,93.2,0,0,0,400.33,192c-5.59,1.6-8.54,8.12-12.18,16.73-2.89,6.81-1.81,13.74,3.34,18.8.09,4.51-1.34,12.33.9,13.71,12.05,7.39,41.67,5.55,46.65-.55,1.85-2.13,1.13-6.24,2.37-10.08C444.52,221,449.29,208.74,446.82,196.71Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.43,170.89v33.69s22.55,6.61,32-2.21V155.82s-6.6,12.41-16.53,16.65S413.43,170.89,413.43,170.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.66,217.15s-28.8-5.73-30.44-6.92c-1.4-1-1.85-2.67-2.55-4.15a19.43,19.43,0,0,0-3.18-4.61c-.82-.92-1.81-1.71-2.57-2.66s-1-2-1.69-2.91-1.62-.25-2.05.62a5.17,5.17,0,0,0,.09,3.92c.21.55.4,1.11.62,1.66a8.67,8.67,0,0,1,.6,1.53,1.3,1.3,0,0,1-.06.83c-.31.52-1.29.17-1.72,0a23.11,23.11,0,0,1-7.75-5.15c-.95-.95-1.69-2-2.7-2.92a11.93,11.93,0,0,0-3.11-2.06,4.24,4.24,0,0,0-2.44-.44c-1.25.46.14,2.44.46,3.11a4.51,4.51,0,0,1,.58,2.41,3.86,3.86,0,0,0,.85,2.76,7.26,7.26,0,0,1,1.58,2.8,8.22,8.22,0,0,1,0,1.11,5.53,5.53,0,0,0,1.33,3.08,4.42,4.42,0,0,1,1.15,2.88c.26,2.44,2.81,4.23,4.7,5.4a32.71,32.71,0,0,0,7,3.09c1.31.43,2.59,1,3.9,1.36s2.4.58,3.55,1c2.74,1.05,23.95,9.13,32.4,11.47,4.17,1.15,5.3,2.18,11.16-.88,10.57-5.51,20.93-9.29,27-13,8.33-5.11,11.87-8,13-13.4,2.63-12.6-5.67-14.93-5.67-14.93-3,.78-4.61,1.49-13.86,6.84C376,204.71,355.66,217.15,355.66,217.15Z",
    style: {
      fill: "#ffbda7"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.63,101.51,427.77,98c.62-2.87-11.11,3.9-11.72,6.77l3.78,8.67a1.65,1.65,0,0,0,.63.74c.83.51,3.88,2.23,4.15,2.39a1.64,1.64,0,0,0,2.42-.89l4.89-15.28C432.22,98.93,429.52,99.86,426.63,101.51Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.63,101.51,427.77,98c.62-2.87-11.11,3.9-11.72,6.77l3.78,8.67a1.65,1.65,0,0,0,.63.74c.83.51,3.88,2.23,4.15,2.39a1.64,1.64,0,0,0,2.42-.89l4.89-15.28C432.22,98.93,429.52,99.86,426.63,101.51Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442.57,42.73,398,68.44a3.31,3.31,0,0,0-1.51,2.61V114.3a3.29,3.29,0,0,0,1.51,2.59l2.76,1.56a3.38,3.38,0,0,0,3,0l44.57-25.72a3.31,3.31,0,0,0,1.51-2.61V46.87a3.31,3.31,0,0,0-1.51-2.6l-2.76-1.56A3.38,3.38,0,0,0,442.57,42.73Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.57,42.73,398,68.44a3.31,3.31,0,0,0-1.51,2.61V114.3a3.29,3.29,0,0,0,1.51,2.59l2.76,1.56a3.38,3.38,0,0,0,3,0l44.57-25.72a3.31,3.31,0,0,0,1.51-2.61V46.87a3.31,3.31,0,0,0-1.51-2.6l-2.76-1.56A3.38,3.38,0,0,0,442.57,42.73Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.35,46,403.78,71.71a3.33,3.33,0,0,0-1.5,2.61v43.25c0,1,.67,1.35,1.5.87l17.06-9.84,3.13,7.18a1.64,1.64,0,0,0,3.06-.15l4.16-13,17.16-9.9a3.31,3.31,0,0,0,1.51-2.61V46.87C449.86,45.91,449.19,45.52,448.35,46Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.35,46,403.78,71.71a3.33,3.33,0,0,0-1.5,2.61v43.25c0,1,.67,1.35,1.5.87l17.06-9.84,3.13,7.18a1.64,1.64,0,0,0,3.06-.15l4.16-13,17.16-9.9a3.31,3.31,0,0,0,1.51-2.61V46.87C449.86,45.91,449.19,45.52,448.35,46Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.84,46.59c-.12-.76-.74-1-1.49-.6L403.79,71.71a3,3,0,0,0-1.07,1.13L397,69.51a3,3,0,0,1,1-1.07l44.57-25.71a3.35,3.35,0,0,1,3,0l2.75,1.56A3.31,3.31,0,0,1,449.84,46.59Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "freepik--contact--inject-52",
    d: "M426.07,81.78c2.88-1.67,5.22-6.13,5.22-10s-2.34-5.61-5.22-4-5.22,6.13-5.22,10S423.19,83.44,426.07,81.78Zm8.78,2.31c-.36-2.56-2.15-3.54-4.25-2.33L421.54,87c-2.1,1.22-3.9,4.27-4.25,7.23l-.63,5.28c-.06.49.21.76.56.56l17.69-10.22a1.33,1.33,0,0,0,.56-1.21Z",
    style: {
      fill: "#fafafa"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalpersonalfilesAmico1);
export default __webpack_public_path__ + "static/media/Digital personal files-amico (1).a047804b660da91e405d609d9983fa1b.svg";
export { ForwardRef as ReactComponent };